if (!customElements.get('media-feature-cards')) {
  class MediaFeatureCards extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-feature-cards-track]');
      this.dots = Array.from(this.querySelectorAll('[data-feature-cards-dot]'));

      if (!this.track || this.dots.length < 2) return;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const cards = this.track.querySelectorAll('.media-feature-cards__card');
          const target = cards[Number(dot.dataset.index)];
          if (!target) return;
          this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    onScroll() {
      const cards = Array.from(this.track.querySelectorAll('.media-feature-cards__card'));
      if (!cards.length) return;

      const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
      let activeIndex = 0;
      let minDistance = Infinity;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.clientWidth / 2;
        const distance = Math.abs(trackCenter - cardCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }
  }

  customElements.define('media-feature-cards', MediaFeatureCards);
}
